// ----------------------------------------------------------------------

type SlotLike = ((props: unknown) => Record<string, unknown>) | Record<string, unknown> | undefined

function getSlotStyles(slot: SlotLike, props: unknown) {
  const slotStyles = typeof slot === 'function' && props ? slot(props) : (slot ?? {});

  return slotStyles;
}

// ----------------------------------------------------------------------

type SettingsStateLike = { direction?: string; fontFamily?: string; fontSize?: string | number; contrast?: string; primaryColor?: string } & Record<string, unknown>

export function updateComponentsWithSettings(components: Record<string, any>, settingsState?: SettingsStateLike) {
  const MuiCard = {
    styleOverrides: {
      root: (props: { theme: import('@mui/material/styles').Theme } & Record<string, unknown>) => {
        const { theme } = props;

        const rootStyles = getSlotStyles(components?.MuiCard?.styleOverrides?.root, props);

        return {
          ...rootStyles,
          ...(settingsState?.contrast === 'hight' && {
            boxShadow: theme.vars.customShadows.z1,
          }),
        };
      },
    },
  };

  const MuiCssBaseline = {
    styleOverrides: {
      html: {
        fontSize: settingsState?.fontSize,
      },
    },
  };

  return {
    components: {
      MuiCard,
      MuiCssBaseline,
    },
  };
}
